// extracted by mini-css-extract-plugin
export default {"DeleteButton":"ShortcutApiKey_DeleteButton__Cjylr","List__Item":"ShortcutApiKey_List__Item__CW1zk","List":"ShortcutApiKey_List__JvDtR"};